<template>
  <div class="login vibrant-background-1">
    <a-row>
      <a-col :offset="6" :span="12">
        <div class="login-form-wrapper form-3d form-3d__hover">
          <h1 class="text-center">Login</h1>
          <a-alert v-if="loginError" type="error" message="Invalid username or password" banner />
          <a-form @submit="handleSubmit" :autoFormCreate="(form)=>{this.form = form}">
            <a-form-item label='Username' :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" fieldDecoratorId="username"
              :fieldDecoratorOptions="{rules: [{ required: true, message: 'Please enter your username' }]}">
              <a-input v-model="username" />
            </a-form-item>
            <a-form-item label='Password' :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" fieldDecoratorId="password"
              :fieldDecoratorOptions="{rules: [{ required: true, message: 'Please enter your password' }]}">
              <a-input type="password" v-model="password" />
            </a-form-item>
            <a-form-item class="text-center" :wrapperCol="{ span: 24}">
              <a-button type='primary' htmlType='submit'>
                Submit
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
import store from "@/store";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      loginError: false
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      event.stopPropagation();

      console.log(this.$route.params);

      this.loginError = false;

      store
        .dispatch("login", {
          creds: {
            username: this.username,
            password: this.password
          }
        })
        .then(resp => {
          this.loginError = false;
          this.$notify({
            group: "main",
            title: "Logged in!",
            text: `Welcome back, ${resp.data[0].username}!`
          });
          this.$router.push('/');
        })
        .catch(err => {
          this.loginError = true;
        });
    }
  }
};
</script>

<style lang="less">
.login {
  padding-top: 80px;
  min-height: 600px;
}
.login-form-wrapper {
  background: rgba(255, 255, 255, 0.99);
}
</style>
